export enum EProcessType {
  Unknown = 0,
  TimeOff = 1,
  //Bonuses = 2,
  //payroll = 3,
  Onboarding = 4,
  //Truck
  MaintRequest = 50,
  SupplyRequest = 51
}

export const EProcessTypeMapping: Record<EProcessType, string> = {
  [EProcessType.Unknown]: 'Request',
  [EProcessType.TimeOff]: 'Time Off',
  //[RequestGroup.Bonuses]: 'Bonuses',
  //[RequestGroup.Payroll]: 'Payroll',
  [EProcessType.Onboarding]: 'On Boarding',
  [EProcessType.MaintRequest]: 'Maint. Request',
  [EProcessType.SupplyRequest]: 'Supply Request'
};

export const EProcessTypeUrlMapping: Record<EProcessType, string> = {
  [EProcessType.Unknown]: '',
  [EProcessType.TimeOff]: 'time-off',
  //[RequestGroup.Bonuses]: 'bonuses',
  //[RequestGroup.Payroll]: 'payroll',
  [EProcessType.Onboarding]: '',
  [EProcessType.MaintRequest]: 'maint-request',
  [EProcessType.SupplyRequest]: 'supply-request'
};

export const EProcessEmployeeRelatedTypes: EProcessType[] = [EProcessType.TimeOff];
